import React from 'react';
import '../../styles/Contacto.css';

export default function Contacto() {
    return (
        <div id='contacto' className="contacto__div--container">
            <div className="contacto__div--seccion-contacto">
                <h2 className="contacto__h2--contacto">Contacto</h2>
                <ul className="contacto__ul--lista">
                    <li>Steven Sańchez López</li>
                    <li>Naci en Medellín, Colombia</li>
                    <li>Vivo en Medellín, Colombia</li>
                    <li>stevendevofi@gmail.com</li>
                    <li>+57 3007162596</li>
                </ul>
            </div>
        </div>
    )
}
